/* eslint-disable react/jsx-no-duplicate-props */
import React, { Component } from 'react'
import {
    Row,
    Col,
    Modal,
    Input,
    Button,
    Mentions,
    Tooltip,
    Avatar,
    Icon,
    Select,
} from 'antd'
import { FaPlusCircle } from 'react-icons/fa'
import QMAction from '../../redux/quickMessage/actions'
// redux
import { connect } from 'react-redux'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import SelectMediaComponent from '../select_medias'
import SelectObjectComponent from '../select_objects'
import SelectEventComponent from '../select_events'
import scrumBoardActions from '../../redux/scrumBoard/actions'
import defaultImgEvent from '../../resource/image/imgEventDefaul.jpg'
import objectDefault from '../../resource/image/objectDefault.png'
import { IoIosClose } from 'react-icons/io'
import { IconSvg } from '../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import { getListOrgNotCheckAPI } from '../../services/apis/OrganizationsAPIService'
const default_avatar = require('../../resource/image/defaultUser.png')

const { TextArea } = Input
const { Option } = Mentions

class CreateNewMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            content: '',
            uid_receiver: [],
            title: '',
            currentReceiver: [],
            crrText: '',
            crrTextOrg: '',
            crrOrgreceiver: [],
            listCrrOrg: [],
        }
    }
    componentDidMount() {
        this.props.updateListCurrentEvent([])
        this.props.applyToCurrentObject([])
        this.props.applyToMedia([])
        this.props.getCurrentListOrg()
        this.getDataOrg()
    }

    getDataOrg = async () =>{
        let data = await getListOrgNotCheckAPI(0)
        console.log("getDataOrg ", data)
        if(data.error.code === 200){
            this.setState({listCrrOrg: data.data})
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops !== this.props) {
        }
    }
    _userSelectMedia = medias => {
        console.log('medias : ', medias)
        this.props.showModalMedia(false)
        this.props.applyToMedia([])
        this.props.applyToMedia(medias)
    }
    _userSelectObject = objects => {
        this.props.showModalObject(false)
        this.props.applyToCurrentObject([])
        this.props.applyToCurrentObject(objects)
    }
    _userSelectEvent = events => {
        this.props.visibleModalEvent(false)
        this.props.updateListCurrentEvent([])
        this.props.updateListCurrentEvent(events)
    }
    sendMessage = () => {
        let lstEvent = []
        this.props.ListCurrentEvent.map(event => {
            lstEvent.push(event.event_id)
        })
        let lstobject = []
        this.props.ListCurrentObject.map(obj => {
            lstobject.push(obj.object_id)
        })
        let lstmedia = []
        this.props.ListCurrentMedia.map(media => {
            lstmedia.push(media.media_id)
        })
        const body = {
            content: this.state.content,
            event: lstEvent,
            hashtag: [],
            media: lstmedia,
            object: lstobject,
            title: this.state.title,
        }
        let crruid = []
        this.state.currentReceiver.map(user => {
            crruid.push(user.uid)
        })
        let crrOid = []
        this.state.crrOrgreceiver.map(org => {
            crrOid.push(org.oid)
        })
        console.log('crrOid', crrOid)
        this.props.sendMessage(crruid, crrOid, body)
        this.props.onSendEnd()
        this.props.updateListCurrentEvent([])
        this.props.applyToCurrentObject([])
        this.props.applyToMedia([])
    }
    isCanSubmit = () => {
        let bool = true
        if (this.state.content === '' || this.state.title === '') {
            bool = false
        }
        if (this.state.currentReceiver.length === 0) {
            bool = false
        }
        return bool
    }
    MyUploadAdapterPlugin(editor) {
        console.log('img editor', editor.plugins.get('FileRepository'))
    }
    handleChangeOrg = value => { }

    render() {
        console.log('this.props.listUser', this.state.listCrrOrg)
        return (
            <div
                span={20}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: 15,
                    height: window.innerHeight,
                }}
            >
                <div>
                    <h7 style={{ color: 'white', padding: 10 }}>*Tiêu đề</h7>
                    <TextArea
                        onChange={vl => {
                            this.setState({ title: vl.target.value })
                        }}
                        rows={1}
                        placeholder="Nhập tiêu đề"
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <h7 style={{ color: 'white', padding: 10 }}>*Người nhận</h7>
                    <Mentions
                        placeholder="Nhập @ và tên người cần gửi để chọn"
                        onChange={vl => {
                            this.setState({ crrText: vl })
                            if (vl.lastIndexOf('@') !== -1) {
                                let text = vl.slice(
                                    vl.lastIndexOf('@') + 1,
                                    vl.length
                                )
                                this.props.getListuserByText(text)
                            }
                        }}
                        value={this.state.crrText}
                        onSelect={(vl, key) => {
                            console.log('data select', vl)
                            console.log('key select', key)
                            let data = vl.data
                            this.setState({
                                currentReceiver: this.state.currentReceiver.concat(
                                    data
                                ),
                            })
                            this.setState({ crrText: '' })
                        }}
                        defaultValue=""
                    >
                        {this.props.listUser.map(user => (
                            <Option
                                key={user.uid}
                                value={user.display_name + user.uid}
                                data={user}
                            >
                                <div
                                >
                                    <Avatar
                                        src={
                                            user.avatar === ''
                                                ? default_avatar
                                                : user.avatar
                                        }
                                    />
                                    <text style={{ paddingLeft: 5 }}>
                                        {user.display_name}
                                    </text>
                                </div>
                            </Option>
                        ))}
                    </Mentions>
                    {this.state.currentReceiver.map(user => (
                        <div style={{ padding: 10, color: 'white' }}>
                            <Avatar
                                src={
                                    user.avatar === ''
                                        ? default_avatar
                                        : user.avatar
                                }
                            />
                            <text style={{ paddingLeft: 5 }}>
                                {user.display_name}
                            </text>
                            <IoIosClose
                                onClick={() => {
                                    let lstuser = this.state.currentReceiver.filter(
                                        vl => {
                                            return vl.uid !== user.uid
                                        }
                                    )
                                    this.setState({ currentReceiver: lstuser })
                                }}
                                size={25}
                                style={{ paddingLeft: 5, cursor: 'pointer' }}
                            />
                        </div>
                    ))}
                </div>
                <div style={{ marginTop: 10 }}>
                    <h7 style={{ color: 'white', padding: 10 }}>Đơn vị nhận</h7>
                    <Mentions
                        placeholder="Nhập @ và tên đơn vị cần gửi để chọn"
                        value={this.state.crrTextOrg}
                        onChange={vl => {
                            this.setState({ crrTextOrg: vl })

                        }}
                        onSelect={vl => {
                            this.setState({ crrTextOrg: '' })
                            let data = vl.data
                            this.setState({
                                crrOrgreceiver: this.state.crrOrgreceiver.concat(
                                    data
                                ),
                            })

                            let dataOrg = this.state.listCrrOrg.filter(
                                vl => {
                                    return data.oid !== vl.oid
                                }
                            )
                            this.setState({listCrrOrg: dataOrg})
                            // this.props.getCurrentListOrgDone(dataOrg)

                        }}
                        defaultValue=""
                    >
                        {this.state.listCrrOrg && this.state.listCrrOrg.map(org => (
                            <Option
                                value={org.name}
                                data={org}
                            >
                                <div

                                >
                                    <Avatar
                                        src={
                                            org.ext_data.avatarOrgani
                                        }
                                    />
                                    <text style={{ paddingLeft: 5 }}>
                                        {org.name}
                                    </text>
                                </div>
                            </Option>
                        ))}
                    </Mentions>

                    {this.state.crrOrgreceiver.map(org => (
                        <div style={{ padding: 10, color: 'white' }}>
                            <Avatar
                                src={
                                    org.ext_data.avatarOrgani
                                }
                            />
                            <text style={{ paddingLeft: 5 }}>
                                {org.name}
                            </text>
                            <IoIosClose
                                onClick={() => {
                                    let lstuser = this.state.crrOrgreceiver.filter(
                                        vl => {
                                            return vl.oid !== org.oid
                                        }
                                    )
                                    this.setState({ crrOrgreceiver: lstuser })
                                    let dataOrg = this.state.listCrrOrg.concat(org)
                                    this.setState({listCrrOrg: dataOrg})
                                    // this.props.getCurrentListOrgDone(dataOrg)
                                }}
                                size={25}
                                style={{ paddingLeft: 5, cursor: 'pointer' }}
                            />
                        </div>
                    ))}
                </div>
                <Row style={{ margin: 10, color: 'white' }}>
                    <Col
                        span={8}
                        style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <text>Tài liệu liên quan</text>
                        {this.props.ListCurrentMedia.map(media => (
                            <a
                                type="link"
                                // href={media.url}
                                target="_blank"
                                onClick={() => {
                                    window.open(media.url, '_blank')
                                }}
                                block={false}
                                style={{
                                    paddingLeft: 5,
                                    color: '#1a73e8',
                                    textDecorationLine: 'underline',
                                    paddingRight: 10,
                                }}
                            >
                                {media.name}
                            </a>
                        ))}
                        <Button
                            type="primary"
                            icon="upload"
                            onClick={() => this.props.showModalMedia(true)}
                            style={{
                                width: 170,
                                marginTop: 10,
                                justifyContent: 'center',
                            }}
                        >
                            Chọn tài liệu
                        </Button>
                    </Col>
                    <Col
                        span={8}
                        style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <text>Sự kiện liên quan</text>
                        <div>
                            {this.props.ListCurrentEvent.map(event => (
                                <Tooltip
                                    title={event.name}
                                    placement="bottom"
                                    key={event}
                                >
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={`/app/qbevents/${event.event_id}`}
                                    >
                                        <Avatar
                                            shape="square"
                                            size={64}
                                            src={
                                                event.avatar === ''
                                                    ? defaultImgEvent
                                                    : event.avatar
                                            }
                                            style={{
                                                margin: 10,
                                            }}
                                        />
                                    </a>
                                </Tooltip>
                            ))}
                        </div>
                        <Button
                            type="primary"
                            icon="upload"
                            onClick={() => this.props.visibleModalEvent(true)}
                            style={{
                                marginTop: 10,
                                width: 170,
                                justifyContent: 'center',
                            }}
                        >
                            Chọn sự kiện
                        </Button>
                    </Col>
                    <Col
                        span={8}
                        style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <text>Đối tượng liên quan</text>
                        <div>
                            {this.props.ListCurrentObject.map(object => (
                                <Tooltip
                                    title={object.name}
                                    placement="bottom"
                                    key={object}
                                >
                                    <Avatar
                                        shape="square"
                                        size={64}
                                        src={
                                            object.avatar === ''
                                                ? objectDefault
                                                : object.avatar
                                        }
                                        style={{ margin: 10 }}
                                    />
                                </Tooltip>
                            ))}
                        </div>
                        <Button
                            type="primary"
                            icon="upload"
                            onClick={() => this.props.showModalObject(true)}
                            style={{
                                marginTop: 10,
                                width: 170,
                                justifyContent: 'center',
                            }}
                        >
                            Chọn đối tượng
                        </Button>
                    </Col>
                </Row>

                <div style={{ marginTop: 10 }}>
                    <h7 style={{ color: 'white', padding: 10 }}>*Nội dung</h7>
                    <CKEditor
                        editor={ClassicEditor}
                        data=""
                        onInit={editor => {
                            // You can store the "editor" and use when it is needed.
                            console.log('Editor is ready to use!', editor)
                        }}
                        config={{
                            extraPlugins: [this.MyUploadAdapterPlugin],
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData()
                            this.setState({ content: data })
                        }}
                    />
                </div>
                <Button
                    type="primary"
                    style={{ width: 150, margin: 15 }}
                    onClick={() => {
                        this.sendMessage()
                    }}
                    disabled={!this.isCanSubmit()}
                >
                    Gửi báo cáo
                </Button>
                {this.props.VisibleModalMedia && (
                    <Modal
                        visible={true}
                        title="Lựa chọn tài liệu"
                        onOk={() => this.props.showModalMedia(false)}
                        onCancel={() => this.props.showModalMedia(false)}
                        centered
                        width={900}
                        footer={null}
                    >
                        <SelectMediaComponent
                            onSuccess={medias => this._userSelectMedia(medias)}
                            onCancel={() => this.props.showModalMedia(false)}
                            initMedia={this.props.ListCurrentMedia}
                        />
                    </Modal>
                )}
                {this.props.VisibleModalObject && (
                    <Modal
                        visible={true}
                        title="Lựa chọn đối tượng"
                        onOk={() => this.props.showModalObject(false)}
                        onCancel={() => this.props.showModalObject(false)}
                        width={900}
                        centered
                        footer={[]}
                    >
                        <SelectObjectComponent
                            onSuccess={objects =>
                                this._userSelectObject(objects)
                            }
                            onCancel={() => this.props.showModalObject(false)}
                            initObject={this.props.ListCurrentObject}
                        />
                    </Modal>
                )}
                {this.props.VisibleModalEvent && (
                    <Modal
                        visible={true}
                        title="Sự kiện liên quan"
                        onOk={() => this.props.visibleModalEvent(false)}
                        onCancel={() => this.props.visibleModalEvent(false)}
                        width={900}
                        centered
                        footer={[]}
                    >
                        <SelectEventComponent
                            onSuccess={events => this._userSelectEvent(events)}
                            onCancel={() => this.props.visibleModalEvent(false)}
                            initEvent={this.props.ListCurrentEvent}
                        />
                    </Modal>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        listUser: state.QMreducer.listUser,
        VisibleModalMedia: state.scrumBoard.VisibleModalMedia,
        VisibleModalObject: state.scrumBoard.VisibleModalObject,
        VisibleModalEvent: state.scrumBoard.VisibleModalEvent,
        ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
        ListCurrentObject: state.scrumBoard.ListCurrentObject,
        ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
        listCrrOrg: state.QMreducer.listCrrOrg,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListuserByText: text => {
            dispatch(QMAction.action.getListuserByText(text))
        },
        sendMessage: (uid, crrOid, body) => {
            dispatch(QMAction.action.sendMessage(uid, crrOid, body))
        },
        visibleModalEvent: visible => {
            dispatch(scrumBoardActions.visibleModalEvent(visible))
        },
        showModalMedia: visible => {
            dispatch(scrumBoardActions.showModalMedia(visible))
        },
        showModalObject: visible => {
            dispatch(scrumBoardActions.showModalObject(visible))
        },
        applyToMedia: data => {
            dispatch(scrumBoardActions.applyToMedia(data))
        },
        applyToCurrentObject: data => {
            dispatch(scrumBoardActions.applyToCurrentObject(data))
        },
        updateListCurrentEvent: data => {
            dispatch(scrumBoardActions.updateListCurrentEvent(data))
        },
        getCurrentListOrg: () => {
            dispatch(QMAction.action.getCurrentListOrg())
        },
        getCurrentListOrgDone: (data) => {
            dispatch(QMAction.action.getCurrentListOrgDone(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateNewMessage)
